"use strict";
export { useWalletDisplay } from "components/Web3Status/useWalletDisplay";
export function RecentlyConnectedModal() {
  return null;
}
